import { CommunicationChannel } from "@mimber/schema"

export const SAMPLE_VARIABLE_CONTEXT: Record<string, string> = {
  member_name: "Jane Doe",
  member_email: "jane.doe@example.com",
  organization_name: "Your Organization",
  announcement_title: "Sample Announcement",
}

export const CHANNEL_LABEL: Record<CommunicationChannel, string> = {
  [CommunicationChannel.EMAIL]: "Email",
  [CommunicationChannel.SMS]: "SMS",
  [CommunicationChannel.PUSH]: "Push",
}
